import type { loadingToast } from '@side/pantry';

export type LoadingToastMessages = Parameters<typeof loadingToast>[1];

export type FieldErrorConfig = {
  name: string;
  data: {
    type: string;
    message: string;
  };
};

export enum AllowedImageFileExtensions {
  JPEG = 'jpeg',
  JPG = 'jpg',
  PNG = 'png',
  BMP = 'bmp',
  TIFF = 'tiff',
  WEBP = 'webp',
}
